/** Text and email parsing utilities for trigger preview components. */

/**
 * Decode HTML entities in text
 */
export function decodeHtmlEntities(text: string): string {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
}

/**
 * Extract just the name from an email "Name <email@example.com>" format
 */
export function extractSenderName(from: string): string {
  const match = from.match(/^([^<]+)\s*</);
  if (match) {
    return match[1].trim();
  }
  const emailMatch = from.match(/^<?([^<@]+)@/);
  if (emailMatch) {
    return emailMatch[1].trim();
  }
  return from;
}

/**
 * Extract email address from "Name <email@example.com>" format
 */
export function extractSenderEmail(from: string): string {
  const match = from.match(/<([^>]+)>/);
  if (match) {
    return match[1].trim();
  }
  if (from.includes('@')) {
    return from.trim();
  }
  return '';
}
